import { Controller } from "stimulus";

export default class extends Controller {
  triggerModal(e) {
    e.preventDefault()

    const learnerId = e.target.dataset.learnerId
    const learnerTrainingId = e.target.dataset.learnerTrainingId

    Rails.ajax({
      url: `/learners/${learnerId}/learner_trainings/${learnerTrainingId}/share_certificate`,
      type: 'get',
      dataType: 'script'
    })
  }
}
